var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ctm-s3-settings" },
    [
      _vm.loading
        ? _c("div", { staticClass: "ctm-s3-settings__loading" }, [
            _c("i", { staticClass: "el-icon-loading" }),
            _vm._v(" Loading…\n    ")
          ])
        : [
            _vm._m(0),
            _vm._v(" "),
            _vm.settings.access_key
              ? _c("div", { staticClass: "ctm-s3-settings__status-row" }, [
                  _c(
                    "span",
                    {
                      class: [
                        "ctm-s3-settings__badge",
                        _vm.settings.status ? "is-connected" : "is-disconnected"
                      ]
                    },
                    [
                      _c("i", {
                        class: _vm.settings.status
                          ? "el-icon-circle-check"
                          : "el-icon-warning-outline"
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.settings.status
                              ? "Connected — bucket is reachable"
                              : "Not connected — save credentials to verify"
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-form",
              {
                staticClass: "ctm-s3-settings__form",
                attrs: { "label-position": "top" }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Access Key ID" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "AKIAIOSFODNN7EXAMPLE",
                                autocomplete: "off"
                              },
                              model: {
                                value: _vm.settings.access_key,
                                callback: function($$v) {
                                  _vm.$set(_vm.settings, "access_key", $$v)
                                },
                                expression: "settings.access_key"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Secret Access Key" } },
                          [
                            _c(
                              "el-input",
                              {
                                attrs: {
                                  type: _vm.showSecret ? "text" : "password",
                                  placeholder: "••••••••••••••••••••",
                                  autocomplete: "new-password"
                                },
                                model: {
                                  value: _vm.settings.secret_key,
                                  callback: function($$v) {
                                    _vm.$set(_vm.settings, "secret_key", $$v)
                                  },
                                  expression: "settings.secret_key"
                                }
                              },
                              [
                                _c("i", {
                                  class: _vm.showSecret
                                    ? "el-icon-view"
                                    : "el-icon-minus",
                                  staticStyle: {
                                    cursor: "pointer",
                                    "margin-right": "6px"
                                  },
                                  attrs: { slot: "suffix" },
                                  on: {
                                    click: function($event) {
                                      _vm.showSecret = !_vm.showSecret
                                    }
                                  },
                                  slot: "suffix"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "ctm-s3-settings__help" }, [
                              _vm._v(
                                "\n                            Stored securely in WordPress options. Use an IAM user with\n                            "
                              ),
                              _c("code", [_vm._v("s3:PutObject")]),
                              _vm._v(", "),
                              _c("code", [_vm._v("s3:DeleteObject")]),
                              _vm._v(
                                " on your bucket only.\n                        "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Bucket Name" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "my-forms-bucket" },
                              model: {
                                value: _vm.settings.bucket,
                                callback: function($$v) {
                                  _vm.$set(_vm.settings, "bucket", $$v)
                                },
                                expression: "settings.bucket"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Region" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.settings.region,
                                  callback: function($$v) {
                                    _vm.$set(_vm.settings, "region", $$v)
                                  },
                                  expression: "settings.region"
                                }
                              },
                              [
                                _c(
                                  "el-option-group",
                                  { attrs: { label: "US" } },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label:
                                          "US East (N. Virginia) — us-east-1",
                                        value: "us-east-1"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "US East (Ohio) — us-east-2",
                                        value: "us-east-2"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "US West (Oregon) — us-west-2",
                                        value: "us-west-2"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label:
                                          "US West (N. California) — us-west-1",
                                        value: "us-west-1"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-option-group",
                                  { attrs: { label: "Europe" } },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: "Europe (Ireland) — eu-west-1",
                                        value: "eu-west-1"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Europe (London) — eu-west-2",
                                        value: "eu-west-2"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label:
                                          "Europe (Frankfurt) — eu-central-1",
                                        value: "eu-central-1"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Europe (Paris) — eu-west-3",
                                        value: "eu-west-3"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label:
                                          "Europe (Stockholm) — eu-north-1",
                                        value: "eu-north-1"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-option-group",
                                  { attrs: { label: "Asia Pacific" } },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label:
                                          "Asia Pacific (Singapore) — ap-southeast-1",
                                        value: "ap-southeast-1"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label:
                                          "Asia Pacific (Sydney) — ap-southeast-2",
                                        value: "ap-southeast-2"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label:
                                          "Asia Pacific (Tokyo) — ap-northeast-1",
                                        value: "ap-northeast-1"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label:
                                          "Asia Pacific (Mumbai) — ap-south-1",
                                        value: "ap-south-1"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-option-group",
                                  { attrs: { label: "Other" } },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label:
                                          "Canada (Central) — ca-central-1",
                                        value: "ca-central-1"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label:
                                          "South America (São Paulo) — sa-east-1",
                                        value: "sa-east-1"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Path Prefix" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "contactum/uploads/" },
                              model: {
                                value: _vm.settings.path_prefix,
                                callback: function($$v) {
                                  _vm.$set(_vm.settings, "path_prefix", $$v)
                                },
                                expression: "settings.path_prefix"
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "ctm-s3-settings__help" }, [
                              _vm._v(
                                "Leading folder for all uploads. Include trailing slash."
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "File Visibility (ACL)" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.settings.acl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.settings, "acl", $$v)
                                  },
                                  expression: "settings.acl"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "Public — direct URL access",
                                    value: "public-read"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label:
                                      "Private — authenticated access only",
                                    value: "private"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "ctm-s3-settings__help" }, [
                              _vm._v(
                                "\n                            Public files get a standard HTTPS URL. Private requires bucket policy/pre-signed URLs.\n                        "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c("el-switch", {
                      model: {
                        value: _vm.settings.delete_local,
                        callback: function($$v) {
                          _vm.$set(_vm.settings, "delete_local", $$v)
                        },
                        expression: "settings.delete_local"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "ctm-s3-settings__switch-label" },
                      [_vm._v("Delete local copy after upload")]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "ctm-s3-settings__help" }, [
                      _vm._v(
                        "Saves server disk space. Cannot be undone — use only when S3 is stable."
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ctm-s3-settings__policy-box" }, [
              _c("p", { staticClass: "ctm-s3-settings__policy-title" }, [
                _vm._v("Minimum IAM Policy")
              ]),
              _vm._v(" "),
              _c("pre", { staticClass: "ctm-s3-settings__policy-code" }, [
                _vm._v(_vm._s(_vm.iamPolicy))
              ])
            ]),
            _vm._v(" "),
            _vm.testResult
              ? _c(
                  "div",
                  {
                    class: [
                      "ctm-s3-settings__test-result",
                      _vm.testResult.ok ? "is-success" : "is-error"
                    ]
                  },
                  [
                    _c("i", {
                      class: _vm.testResult.ok
                        ? "el-icon-circle-check"
                        : "el-icon-circle-close"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.testResult.message) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ctm-s3-settings__actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", loading: _vm.saving },
                    on: { click: _vm.save }
                  },
                  [_vm._v("Save Settings")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { loading: _vm.testing, disabled: !_vm.canTest },
                    on: { click: _vm.testConnection }
                  },
                  [_vm._v("Test Connection")]
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-s3-settings__header" }, [
      _c("span", {
        staticClass: "ctm-s3-settings__icon dashicons dashicons-cloud-upload"
      }),
      _vm._v(" "),
      _c("div", [
        _c("h2", { staticClass: "ctm-s3-settings__title" }, [
          _vm._v("Amazon S3 Storage")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "ctm-s3-settings__desc" }, [
          _vm._v(
            "\n                    Offload form file and image uploads to Amazon S3.\n                    Once connected, enable S3 per-form under\n                    "
          ),
          _c("strong", [_vm._v("Form Settings → Integrations → Amazon S3")]),
          _vm._v(
            ".\n                    Files are stored using your chosen ACL — public files get a direct URL; private files require authenticated access.\n                "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }